export const Environment = Object.freeze({
    LOCALHOST: 'LOCALHOST',
    TEST: 'TEST',
    PROD: 'PROD',
});

export type EnvironmentValue = $Values<typeof Environment>;
